import React, { useState, useEffect } from "react";
import { 
    Card, Row, Col, Form, Button, Spinner, Alert
} from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";

export default function ModifierFournisseur() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [formData, setFormData] = useState({
        raison_sociale: '',
        adresse: '',
        telephone: '',
        email: '',
        ice: '',
        patente: '',
        rc: '',
        identifiant_fiscal: '',  // Changé de 'if' à 'identifiant_fiscal'
        cnss: '',
        conditions_reglement: ''
    });
    const [errors, setErrors] = useState({});
    const [submitError, setSubmitError] = useState('');

    useEffect(() => {
        fetchFournisseur();
    }, [id]);

    const fetchFournisseur = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const response = await fetch(
                `https://sawd.julesferry-ga.com/api/fournisseurs.php?id=${id}`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            
            if (!response.ok) throw new Error("Erreur chargement");
            
            const result = await response.json();
            setFormData(result.data);
        } catch (err) {
            setSubmitError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        
        if (errors[name]) {
            setErrors({ ...errors, [name]: null });
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.raison_sociale) newErrors.raison_sociale = "La raison sociale est requise";
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const newErrors = validateForm();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setSaving(true);
        setSubmitError('');

        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                `https://sawd.julesferry-ga.com/api/fournisseurs.php?id=${id}`,
                {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                }
            );

            const result = await response.json();

            if (result.success) {
                navigate('/achats/fournisseurs');
            } else {
                setSubmitError(result.message || "Erreur lors de la modification");
            }
        } catch (err) {
            setSubmitError("Erreur de connexion au serveur");
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                        <Spinner animation="border" variant="primary" />
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="container-fluid">
                    {/* En-tête */}
                    <Row className="mb-4">
                        <Col md={12}>
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h1 className="page-title mb-1">Modifier {formData.raison_sociale}</h1>
                                    <p className="text-muted">Code: {formData.code_fournisseur}</p>
                                </div>
                                <Button variant="outline-secondary" onClick={() => navigate('/achats/fournisseurs')}>
                                    <i className="ri-arrow-left-line me-2"></i>Retour
                                </Button>
                            </div>
                        </Col>
                    </Row>

                    {submitError && (
                        <Alert variant="danger" className="mb-4">
                            <i className="ri-error-warning-line me-2"></i>
                            {submitError}
                        </Alert>
                    )}

                    <Card className="border-0 shadow-sm">
                        <Card.Body className="p-4">
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6}>
                                        <h5 className="mb-3">Informations générales</h5>
                                        
                                        <Form.Group className="mb-3">
                                            <Form.Label>Raison sociale <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="raison_sociale"
                                                value={formData.raison_sociale || ''}
                                                onChange={handleChange}
                                                isInvalid={!!errors.raison_sociale}
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.raison_sociale}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Code fournisseur</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={formData.code_fournisseur || ''}
                                                disabled
                                                readOnly
                                                className="bg-light"
                                            />
                                            <Form.Text className="text-muted">
                                                Le code fournisseur n'est pas modifiable
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <h5 className="mb-3">Coordonnées</h5>
                                        
                                        <Form.Group className="mb-3">
                                            <Form.Label>Téléphone</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="telephone"
                                                value={formData.telephone || ''}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={formData.email || ''}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>

                                       
                                    </Col>
                                     <Form.Group className="mb-3">
                                            <Form.Label>Adresse</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="adresse"
                                                value={formData.adresse || ''}
                                                onChange={handleChange}
                                                rows={2}
                                            />
                                        </Form.Group>
                                </Row>

                                <Row className="mt-4">
                                    <Col md={12}>
                                        <h5 className="mb-3">Identifiants juridiques</h5>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>ICE</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="ice"
                                                value={formData.ice || ''}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Patente</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="patente"
                                                value={formData.patente || ''}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>RC</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="rc"
                                                value={formData.rc || ''}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Identifiant Fiscal (IF)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="identifiant_fiscal"
                                                value={formData.identifiant_fiscal || ''}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>CNSS</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="cnss"
                                                value={formData.cnss || ''}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Conditions de règlement</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="conditions_reglement"
                                                value={formData.conditions_reglement || ''}
                                                onChange={handleChange}
                                                rows={2}
                                                placeholder="Ex: Paiement à 30 jours, escompte de 2%..."
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="d-flex justify-content-end gap-2 mt-4">
                                    <Button 
                                        variant="outline-secondary" 
                                        onClick={() => navigate('/achats/fournisseurs')}
                                        className="px-4"
                                    >
                                        Annuler
                                    </Button>
                                    <Button 
                                        type="submit" 
                                        variant="primary" 
                                        disabled={saving}
                                        className="px-5"
                                        style={{
                                            background: 'linear-gradient(135deg, #4361ee, #3a56d4)',
                                            border: 'none'
                                        }}
                                    >
                                        {saving ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                Enregistrement...
                                            </>
                                        ) : (
                                            <>
                                                <i className="ri-save-line me-2"></i>
                                                Enregistrer
                                            </>
                                        )}
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
                <Footer />
            </div>
        </>
    );
}